//chapter1
export default {
    id : 14,//chapter number
    title : '14. PFMEA 작성방법 (1) - PFMEA의 준비',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c14.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'PFMEA의 준비',
            ],
            body2 : [
                'PFMEA의 준비에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '14.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '공정 FMEA는 공정의 고장과 원인에 대한 조치가 다루어짐을 보장한다.',//html available
                    answer : "1",
                    explain : '공정 FMEA의 기본적 목적이다.'
                },
                {
                    type : 'ox',
                    question : '공정 FMEA는 공정의 치공구 준비에 앞서 준비되어야 한다.',//html available
                    answer : "1",
                    explain : '공정 FMEA는 치공구의 개발을 지원해야 한다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. PFMEA 작성준비 </h3>
                        <li>검토사항<br>
                        1) Project plan review<br>
                        2) Scope에 포함되어 고려해야 하는 Lessons learned, reference materials<br>
                        3) Team R&R 설정<br>
                        4) 관련자료 검토</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <h3>2. 범위정의와 프로젝트 기획</h3>
                        <li>Base Line PFMEA</li>
                        <li>PFMEA 역할 </li>
                        <li>전개순서 및 조건/고려사항</li>
                        <p class="mg10"></p>
                        <h3>3. 양식 사용방법</h3>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c14.mp4',
        },
    ]
}